$(document).ready(function () {
  const log = window.log;

  // ------------------------ Popup Upsell Timer -----------------------------------
  function PopupUpsellTimer() {
    const popup = $('.popup-upsell'),
      popup_timer = popup.find('.popup-upsell__timer');

    if (!popup_timer.length) return { start: () => { }, stop: () => { } };

    const timer = popup_timer.find('.countdown');
    let time = parseInt(popup_timer.data('timer'), 10) * 60,
      timerInterval;

    const formatTime = t => [Math.floor(t / 3600), Math.floor((t % 3600) / 60), t % 60]
      .map(v => v.toString().padStart(2, '0')).join(':');

    const update = () => {
      if (time < 0) {
        clearInterval(timerInterval);
        popup.removeClass('active').find('.popup-upsell__decline').trigger('click');
        return;
      }
      timer.text(formatTime(time--));
    };

    popup.on('click', e => {
      if ($(e.target).hasClass('modal-overlay')) {
        popup.removeClass('active');
        clearInterval(timerInterval);
        popup.find('.popup-upsell__decline').trigger('click');
      }
    });

    return {
      start: () => { time = parseInt(popup_timer.data('timer'), 10) * 60; update(); timerInterval = setInterval(update, 1000); },
      stop: () => timerInterval && clearInterval(timerInterval)
    };
  }

  // Initialize popup upsell timer
  window.popupUpsellTimer = PopupUpsellTimer();



  // ------------------------ Product Options --Custom Dropdown -----------------------------------
  $('.pdp-main__product-options-dropdown__button, .pdp-main-sticky__product-options-dropdown__button').on('click', (e) => {
    e.stopPropagation();
    $(e.currentTarget).closest('.pdp-main__product-options-dropdown, pdp-main-sticky__product-options-dropdown__button').toggleClass('open');
  });

  // Update button text when an option is selected
  $('.pdp-main__product-options-dropdown__item, .pdp-main-sticky__product-options-dropdown__item').on('click', function () {
    const selectedSize = $(this).find('.item-label').text().trim();
    $(this).closest('.pdp-main__product-options-dropdown, .pdp-main-sticky__product-options-dropdown')
      .find('.pdp-main__product-options-dropdown__button p, .pdp-main-sticky__product-options-dropdown__button p')
      .text(selectedSize);
  });

  // Close dropdown when clicking outside
  $(document).on('click', () => $('.pdp-main__product-options-dropdown, .pdp-main-sticky__product-options-dropdown').removeClass('open'));


  // ------------------------ Upsell V2 Quantity -----------------------------------
  function checkUpsellQuantity() {
    const checkInterval = setInterval(() => {
      if ($('.horizontal-product__quantity-btn').length) {
        clearInterval(checkInterval);
        changeUpsellQuantity();
      }
    }, 500);

    function changeUpsellQuantity() {
      $('.horizontal-product__quantity-btn').on('click', (e) => {
        e.preventDefault();
        const $btn = $(e.currentTarget);
        const $quantity = $btn.closest('.horizontal-product__quantity');
        const $quantityInput = $quantity.find('.horizontal-product__quantity-input');
        const isPlus = $btn.data('quantity-btn') === 'plus';
        const currentQuantity = parseInt($quantityInput.text());
        const newQuantity = isPlus ? currentQuantity + 1 : currentQuantity - 1;

        $quantityInput.attr('data-quantity', newQuantity).text(newQuantity);
      });

      // Handle quick-buy drawer quantity sync
      $('.horizontal-product__cta button').on('click', function () {
        const $btn = $(this);
        const drawerId = $btn.attr('aria-controls');
        if (!drawerId) return;

        const $quantityInput = $btn.closest('.horizontal-product').find('.horizontal-product__quantity-input');
        const currentQuantity = $quantityInput.text();

        // Create a MutationObserver to watch for the drawer appearance
        const observer = new MutationObserver((mutations, obs) => {
          const $drawer = $(`form#${drawerId}`);
          if ($drawer.length) {
            $drawer.find('input[name="quantity"]').val(currentQuantity);
            obs.disconnect(); // Stop observing once we've updated the value
          }
        });

        // Start observing the document for the drawer element
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }
  };

  checkUpsellQuantity();
});